import { reactive } from 'vue';

export const criarDrivePasta = () => {
  return reactive({
    id: 0,
    idep: 0,
    iddrivegrupo: 0,
    idsim: 0,
    dtpasta: "",
    nmpasta: "",
    ativo: "S",
    ckpublica: "N",
    idlogin: 0
  });
}